// extracted by mini-css-extract-plugin
export default {"DragIcon":"styles_DragIcon__kwpsp","DragIcon--disabled":"styles_DragIcon--disabled__C3HaN"};